export default __webpack_public_path__ + "static/media/will-image.ef6d3fb5.gif";